import gql from 'graphql-tag';

export const GEO_LOCATIONS_QUERY = gql`
    query getGeoSuggestion($locationPrefix: String!) {
        geoSuggestion(locationPrefix: $locationPrefix) {
            geoIdentifier
            geoLabel
            geoSubLabel
        }
    }
`;
